import {Box, Stack, Typography} from "@mui/material";
import {EffectType} from "../shared/types/EffectType";
import coin from "../../public/coin-svgrepo-com.svg";
import {MediaSkeleton} from "../shared/ui/MediaSkeleton.tsx";
import {memo, useState} from "react";
import {liquidGlassStyle} from "../app/theme/liquidGlassStyle.ts";
import {ImageIcon} from "../shared/ui/ImageIcon.tsx";

interface IImageEffectCardProps {
    effect: EffectType;
    onClick?: () => void;
}

export const ImageEffectCard = memo(({effect, onClick}: IImageEffectCardProps) => {
    const {imgSrc, description, price, isCustom, title} = effect;
    const [isLoaded, setIsLoaded] = useState(false);

    if (isCustom) {
        return (
            <Stack direction={'row'} spacing={2} width={'85vw'} minWidth={'300px'} height={'70px'} onClick={onClick} sx={{cursor: 'pointer', '@media (hover: hover)': {'&:hover': {
                        opacity: 0.8,
                    }}}}>
                <Stack spacing={0} sx={{flexShrink: 0, position: 'relative'}}>
                    <Stack
                        direction={'column'}
                        alignItems={'center'}
                        padding={'15px 0'}
                        sx={{
                            width: '70px',
                            height: '70px',
                            borderRadius: '12px' +
                                '',
                            ...liquidGlassStyle,
                        }}
                    >
                        <Typography variant={'body2'} sx={{opacity: 0.9, fontWeight: 600, fontSize: '12px'}}>{title}</Typography>
                        <Stack direction={'row'} spacing={'2px'} position={'absolute'} bottom={'5px'} left={'5px'} justifyContent={'center'} alignItems={'center'}>
                            <Typography sx={{fontSize: '12px', fontWeight: '700', color: 'white'}}>{price}</Typography>
                            <Box component={'img'} src={coin} alt={'coin'} width={'12px'} height={'12px'} sx={{opacity: 0.9}}/>
                        </Stack>
                    </Stack>

                    <ImageIcon />
                </Stack>

                <Typography variant={'h6'} sx={{opacity: 0.8, fontWeight: '500', textAlign: 'left', fontSize: '12px'}}>{description}</Typography>
            </Stack>
        );
    }

    return (
        <Stack direction={'row'} spacing={2} width={'85vw'} minWidth={'300px'} height={'70px'} onClick={onClick} sx={{cursor: 'pointer', '@media (hover: hover)': {'&:hover': {
                    opacity: 0.8,
                }}}}>
            <Stack spacing={0} sx={{flexShrink: 0}}>
                {!isLoaded && imgSrc && (
                    <MediaSkeleton
                        width="70px"
                        height="70px"
                        borderRadius="12px"
                    />
                )}
                {imgSrc && (
                    <Box
                        component="img"
                        src={imgSrc}
                        alt={'discover'}
                        onLoad={() => setIsLoaded(true)}
                        sx={{
                            width: '70px',
                            height: '50px',
                            flexShrink: 0,
                            objectFit: 'cover',
                            objectPosition: 'top',
                            borderRadius: '12px 12px 0 0',
                            display: isLoaded ? 'block' : 'none'
                        }}
                    />
                )}
                <Stack
                    direction={'row'}
                    spacing={'4px'}
                    width={'70px'}
                    height={'20px'}
                    borderRadius={'0 0 12px 12px'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    sx={{
                        background: 'rgba(0, 0, 0, 0.4)',
                    }}
                >
                    <Typography sx={{fontSize: '12px', fontWeight: '700', color: 'white'}}>{price}</Typography>
                    <Box component={'img'} src={coin} alt={'coin'} width={'14px'} height={'14px'} sx={{opacity: 0.9}}/>
                </Stack>
            </Stack>

            <Typography variant={'h6'} sx={{opacity: 0.8, fontWeight: '500', textAlign: 'left', fontSize: '12px'}}>{description}</Typography>
        </Stack>
    )
});
